import React, { useState } from "react";
import { useAuth } from "../contexts/authContext";

const Checkout = () => {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(false);

    const handleCheckout = async () => {
        setLoading(true);

        const response = await fetch("http://localhost:3003/api/create-checkout-session", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: currentUser.email, priceId: "price_1QpDEMCokbYIMWBrJYM0T4dl" }), // priceId із Stripe Dashboard
        });

        const { url } = await response.json();

        if (url) {
            window.location.href = url; // 🔹 Редірект на Stripe Checkout
        }
        setLoading(false);
    };

    return (
        <button onClick={handleCheckout} disabled={loading}>
            {loading ? "Redirecting..." : "Pay with Stripe"}
        </button>
    );
};

export default Checkout;
